import { motion } from "framer-motion";

const OPTIONS = ["fr", "en"];

export const LanguageToggle = ({ lang, onChange }) => {
  return (
    <div
      data-testid="language-toggle"
      className="relative flex items-center gap-1 rounded-full border p-1"
      style={{ borderColor: "var(--line)", background: "rgba(244,241,237,0.6)", backdropFilter: "blur(10px)" }}
    >
      {OPTIONS.map((opt) => {
        const active = lang === opt;
        return (
          <button
            key={opt}
            data-testid={`lang-${opt}`}
            onClick={() => onChange(opt)}
            className="relative z-10 rounded-full px-3.5 py-1 text-xs font-medium uppercase tracking-[0.15em] transition-colors duration-300"
            style={{ color: active ? "#F4F1ED" : "var(--muted)" }}
          >
            {active && (
              <motion.span
                layoutId="lang-pill"
                className="absolute inset-0 -z-10 rounded-full"
                style={{ background: "var(--ink)" }}
                transition={{ type: "spring", stiffness: 380, damping: 32 }}
              />
            )}
            {opt}
          </button>
        );
      })}
    </div>
  );
};
